export default {
	seo_meta_title_leaguepass: 'NBA | วิดีโอ NBA และไฮไลท์',
	seo_meta_desc_leaguepass: 'วิดีโอ NBA จะเน้นวิดีโอ NBA และไฮไลท์',
	seo_meta_keywords_leaguepass: 'วิดีโอ NBA, ไฮไลท์ NBA, วิดีโอบาสเกตบอล, การเล่นที่ยอดเยี่ยม, การดังค์, รายการแนะนำ',
	seo_meta_title_featured: 'NBA | แนะนำ',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV Live',
	seo_meta_desc_nbatv: 'NBA TV Live คือการสตรีมรายการตลอด 24 ชั่วโมงต่อวันของ NBA TV Channel ถ่ายทอดการแข่งขัน NBA ทุกสัปดาห์ทั้งแบบถ่ายทอดสดและย้อนหลัง โปรแกรมในสตูดิโอและการรายงานข้อมูลจากนักวิเคราะห์',
	seo_meta_keywords_nbatv: 'คุณสามารถรับชมการแข่งขันผ่านรายการต่างๆ ดังนี้ NBA TV Channel, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Gametime, Fantasy Insider, Studio Shows, The Jump',
	seo_meta_title_classicgames: 'NBA | การแข่งขันคลาสสิก',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | รายการวิดีโอ',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'NBA | รายการต่างๆ ของ NBA TV',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'หน้าแรกของ NBA',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | ช่องต่างๆ',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | ช่อง',
	seo_meta_pre_title_categories: 'NBA | หมวดหมู่',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | ประเภท',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | วิดีโอ',
	seo_meta_pre_title_event: 'NBA | กิจกรรม',
	seo_meta_title_events: 'NBA | กิจกรรมต่างๆ',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | กิจกรรมต่างๆ : {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | ค้นหา',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | ไม่พบหน้านี้',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'การแข่งขัน NBA:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | วิดีโอ NBA และไฮไลท์',
	seo_meta_desc_video: 'วิดีโอ NBA จะเน้นวิดีโอ NBA และไฮไลท์',
	seo_meta_keywords_video: 'วิดีโอ NBA, ไฮไลท์ NBA, วิดีโอบาสเกตบอล, การเล่นที่ยอดเยี่ยม, การดังค์, รายการแนะนำ',
	seo_meta_title_channel: 'NBA | NBA TV Live',
	seo_meta_desc_channel: 'NBA TV Live คือการสตรีมรายการตลอด 24 ชั่วโมงต่อวันของ NBA TV Channel ถ่ายทอดการแข่งขัน NBA ทุกสัปดาห์ทั้งแบบถ่ายทอดสดและย้อนหลัง โปรแกรมในสตูดิโอและการรายงานข้อมูลจากนักวิเคราะห์',
	seo_meta_keywords_channel: 'คุณสามารถรับชมการแข่งขันผ่านรายการต่างๆ ดังนี้ NBA TV Channel, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Gametime, Fantasy Insider, Studio Shows, The Jump',
	seo_meta_title_tvguide: 'NBA | ตาราง NBA TV',
	seo_meta_desc_tvguide: 'NBA TV Live คือการสตรีมรายการตลอด 24 ชั่วโมงต่อวันของ NBA TV Channel ถ่ายทอดการแข่งขัน NBA ทุกสัปดาห์ทั้งแบบถ่ายทอดสดและย้อนหลัง โปรแกรมในสตูดิโอและการรายงานข้อมูลจากนักวิเคราะห์',
	seo_meta_keywords_tvguide: 'คุณสามารถรับชมการแข่งขันผ่านรายการต่างๆ ดังนี้ NBA TV Channel, The Beat, Hardwood Classics, NBA Live, Real NBA, NBA Gametime, Fantasy Insider, Studio Shows, The Jump',
	timezone: 'ET',
	default_feed_error_message: 'เกิดข้อผิดพลาด เนื้อหาไม่พร้อมใช้งานในขณะนี้  คุณอาจจะลองดูใหม่อีกครั้ง',
	watch_in_app: 'รับชมบนแอป NBA',
	no_content: 'ไม่มีเนื้อหา',
	see_more: 'ดูเพิ่มเติม',
	now_playing: 'กำลังเล่น',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'LEAGUE PASS',
	league_pass_premium_lock: 'LP ระดับพรีเมี่ยม',
	error_max_limit_favorite: 'คุณมีวิดีโอโปรดครบตามจำนวนสูงสุดแล้ว โปรดลบวิดีโอโปรดบางรายการออกก่อนที่จะเพิ่มวิดีโอใหม่',
	item_live: 'ถ่ายทอดสด:',
	add_favourite_title: 'เพิ่มในรายการโปรด',
	remove_favourite_title: 'ลบออกจากรายการโปรด',
	p_channel_live: 'ถ่ายทอดสด:',
	p_channel_schedule_title: 'ตาราง NBA TV',
	p_channel_schedule_watch: 'ชม',
	p_channel_schedule_no_date: 'ขณะนี้ยังไม่มีวันที่กำหนด',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'ดูตารางทั้งหมด',
	p_channel_live24x7_up_next: 'ถัดไป',
	p_channel_live24x7_on_demand: 'NBA TV: ออนดีมานด์',
	p_channel_live24x7_collection: 'คอลเลกชั่น',
	p_channel_live24x7_demand_1_logo_text: 'รายการปกติ',
	p_channel_live24x7_demand_1_show_name: 'รายการต่างๆ ของ NBA TV',
	p_channel_live24x7_demand_1_show_desc: 'รายการต่างๆ ของ NBA TV ตามปกติรวมถึง Shaqtin \'a Fool, Beyond the Paint, Game Time และ Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'เกมคลาสสิก',
	p_channel_live24x7_demand_2_show_name: 'NBA | การแข่งขันคลาสสิก',
	p_channel_live24x7_demand_2_show_desc: 'ชมการแข่งขันคลาสสิกแบบเต็มเกม รวมถึงคู่ชิงชนะเลิศทุกคู่ตั้งแต่ปี 2000 ช่วงเวลาแห่งประวัติศาสตร์ของลีก และผู้เล่นที่เป็นตำนาน',
	p_channel_clips_title: 'คลิป NBA TV',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'ตารางเวลา',
	p_nba_tv_shows: 'รายการต่างๆ ของ NBA TV',
	p_nba_tv_no_access_title: '24/7 NBA : คอยรับข้อมูลการวิเคราะห์การแข่งขัน การวิเคราะห์จากห้องส่ง รายการปกติ และอีกมากมาย!',
	p_nba_tv_no_access_desc: 'ชมการแข่งขันสดๆ และรายการต่างๆ รวมถึงการแข่งขันสุดคลาสสิกได้ตามต้องการ',
	p_nba_tv_no_access_note: 'อาจมีการระงับสัญญาณภาพ',
	tv_show_item_latest_episode: 'ตอนล่าสุด',
	tv_show_item_no_latest_episode: 'ไม่มีตอนล่าสุด',
	see_all: 'ดูทั้งหมด',
	header_menu_watch: 'ชม',
	header_menu_featured: 'รายการเด่น',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'LEAGUE PASS',
	players: 'ผู้เล่น',
	videos: 'วิดีโอ',
	teams: 'ทีม',
	most_searched: 'ถูกค้นหามากที่สุด',
	no_result: 'ไม่มีข้อมูล',
	search_filter_type_most_relevant: 'มีความเกี่ยวข้องมากที่สุด',
	search_filter_type_most_viewed: 'มีการรับชมมากที่สุด',
	search_filter_type_most_recent: 'ล่าสุด',
	search_filter_type_last_30_days: '30 วันที่ผ่านมา',
	search_filter_type_last_6_months: '6 เดือนที่ผ่านมา',
	search_result_label: 'ผลการค้นหาสำหรับ \'{keyword}\'',
	search_result_info: 'ดูผลลัพธ์ทั้งหมดสำหรับ {keyword}',
	search_placeholder: 'ค้นหาไลบรารีวิดีโอ',
	load_more: 'โหลดเพิ่ม...',
	button_subscribe: 'สมัครรับบริการ',
	button_sign_in: 'ลงชื่อเข้าใช้',
	p_league_pass_no_access_title: 'ชมการแข่งขันสดหรือรีเพลย์บนอุปกรณ์ไหนก็ได้ รวมถึงคอมพิวเตอร์ สมาร์ทโฟนและทีวี!',
	p_league_pass_no_access_desc: 'ตั๋วสู่ความมันส์: จะดูทั้งลีกหรือดูทีมโปรดของคุณก็ได้ เลือกการแข่งขันเดียวหรือดูตัวเลือกอื่นเพิ่มเติม',
	p_league_pass_no_access_note: 'เป็นไปตามข้อกำหนด',
	category_title: 'วิดีโอ',
	p_video_playlist_title: 'เพลย์ลิสต์',
	p_no_access_league_pass_title: 'ปลดล็อก NBA League Pass เพื่อรับชม:',
	p_no_access_league_pass_desc: 'ตั๋วสู่ความมันส์: จะดูทั้งลีกหรือดูทีมโปรดของคุณก็ได้ เลือกการแข่งขันเดียวหรือดูตัวเลือกอื่นเพิ่มเติม',
	p_no_access_league_pass_terms: 'เป็นไปตามข้อกำหนด',
	p_no_access_league_pass_geo_desc: 'จากตำแหน่งปัจจุบันของคุณ คุณไม่สามารถดูการแข่งขันนี้ผ่าน NBA League Pass และ NBA TV ได้ ไฟล์เก็บถาวรของการแข่งขันเหล่านี้จะพร้อมใช้งาน 3 วันหลังจากออกอากาศสำหรับสมาชิก NBA League Pass โปรดสอบถามผู้กระจายเสียงทางวิทยุและโทรทัศน์ในพื้นที่เรื่องตารางออกอากาศเพื่อหาช่องทางการถ่ายทอดการแข่งขันในพื้นที่ของคุณ',
	p_no_access_league_pass_not_found_desc: 'ขออภัย ไม่พบวิดีโอที่คุณต้องการ',
	p_no_access_event_not_found_desc: 'ขออภัย ไม่พบกิจกรรมที่คุณต้องการ',
	p_no_access_nba_tv_title: 'ปลดล็อก NBA TV เพื่อรับชม:',
	p_no_access_nba_tv_desc: 'ชมการแข่งขันสดและรายการต่างๆ รวมถึงการแข่งขันคลาสสิกได้ตามต้องการ',
	p_no_access_nba_tv_terms: 'เป็นไปตามข้อกำหนด',
	p_no_access_nba_tv_geo_desc: 'จากตำแหน่งปัจจุบันของคุณคุณไม่สามารถดูการแข่งขันนี้ผ่าน NBA League Pass และ NBA TV ได้ ไฟล์เก็บถาวรของการแข่งขันเหล่านี้จะพร้อมรับชมในอีก 3 วันหลังจากออกอากาศสำหรับสมาชิก NBA League Pass โปรดสอบถามผู้กระจายเสียงทางวิทยุและโทรทัศน์ในพื้นที่เรื่องตารางออกอากาศเพื่อหาช่องทางการถ่ายทอดการแข่งขันในพื้นที่ของคุณ',
	p_no_access_nba_tv_not_found_desc: 'ขออภัย ไม่พบช่องที่คุณต้องการ',
	p_no_access_up_next: 'ถัดไป:',
	p_video_completed_title: 'เพลย์ลิสต์เสร็จสมบูรณ์',
	p_video_completed_desc: 'กลับไปเรียกดูหรือดูเพลย์ลิสต์ถัดไปสำหรับคุณ',
	p_video_share_to: 'แชร์ไปที่:',
	p_video_more_to_watch: 'ดูเพิ่ม:',
	p_event_section_title: 'กิจกรรม',
	p_event_playlist_title: 'เพลย์ลิสต์',
	p_event_button_watch: 'ชม',
	p_event_button_listen: 'ฟัง',
	p_event_button_ticket: 'ตั๋ว',
	notfound: 'ขออภัย ไม่พบหน้าที่คุณต้องการ',
	notfound_desc: 'โปรดตรวจสอบ URL เพื่อหาข้อผิดพลาด<br/> นอกจากนี้คุณยังสามารถค้นหาเนื้อหาของคุณได้โดยใช้ระบบนำทางในเว็บไซต์หรือเครื่องมือค้นหา',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'บัญชี NBA League Pass ของคุณมีการสตรีมบนอุปกรณ์เกินจำนวนที่กำหนด กรุณาแตะ \'ดำเนินการต่อ\' เพื่อดูต่อบนอุปกรณ์นี้',
	modal_pcm_custom: 'ดำเนินการต่อ',
	modal_pcm_close: 'ยกเลิก',
	modal_adobe_concurrency_header_title: 'วิดีโอขาดการเชื่อมต่อ',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'สตรีมของคุณถูกปิดแล้ว  สาเหตุอาจเกิดจากมีการสตรีมพร้อมกันถึงจำนวนสูงสุดแล้ว สัญญาณหาย หรือมีข้อผิดพลาดทางเทคนิค โปรดลงชื่อเข้าใช้อีกครั้งและเลือกช่องเพื่อดำเนินการต่อ',
	modal_adobe_concurrency_close: 'เสร็จสิ้น',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'วิดีโอนี้ไม่สามารถเล่นบนอุปกรณ์ของคุณ คลิก <a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'>ที่นี่</a> เพื่อรับความช่วยเหลือเพิ่มเติม',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'ตกลง',
	freesample_notice_time: 'เวลาที่เหลือ',
	freesample_notice_title: 'เพลิดเพลินไปกับการเข้าถึง {0} นาที',
	freesample_notice_desc: 'สมัครรับบริการแพ็กเกจ League Pass แบบเต็มรูปแบบเพื่อเข้าถึงเนื้อหาต่อไปหลังจากครบ 10 {0} นาที',
	freesample_notice_subscribe_button: 'สมัครรับบริการ',
	freesample_notice_cancel_button: 'ยกเลิกได้ทุกเมื่อ',
	freesample_popup_title: 'สิทธิ์การเข้าถึงของคุณสิ้นสุดแล้ว',
	freesample_popup_subtitle: 'สมัครรับบริการ League Pass เพื่อชมเนื้อหา NBA ที่น่าสนใจอื่นๆ',
	freesample_popup_link: 'เรียนรู้เพิ่มเติม!',
	freesample_popup_get_minutes_button: 'รับสิทธิ์ {0}  นาที',
	reg_required_desc: 'คุณต้องลงชื่อเข้าใช้เพื่อดูเนื้อหานี้',
	favorite_teams_title: 'ทีมโปรด',
	bookmarked_title: 'บันทึกแล้ว',
	watch_history_title: 'ดูต่อ',
	game_schedule_title: 'ตารางการแข่งขัน',
	recommended_title: 'แนะนำ',
	season_text: 'ฤดูกาล',
	section_tv_provider_title: 'ผู้ให้บริการทีวีของฉัน',
	section_tv_provider_desc: 'รับสิทธิ์เข้าถึงการแข่งขันสดและสตรีมจากผู้ให้บริการทีวีของคุณ',
	section_tv_provider_faq: 'คำถามเกี่ยวกับผู้ให้บริการทีวีที่พบบ่อย',
	section_tv_provider_sign_out: 'ออกจากระบบ',
	header_menu_account_my_account: 'บัญชีของฉัน',
	header_menu_account_manage_account: 'จัดการบัญชี',
	header_menu_account_favorite_teams: 'ทีมโปรด',
	header_menu_account_favorite_players: 'ผู้เล่นคนโปรด',
	header_menu_account_viewing_history: 'ประวัติการเข้าชม',
};
